import { createReducer, on } from '@ngrx/store';
import {
  dashboardInfo,
  dashboardInfoSuccess,
  dashboardInfoFailure,
  services,
  servicesSuccess,
  servicesFailure,
  storeService,
  storeServiceFailure,
  storeServiceSuccess,
  uploadCSV,
  uploadCSVSuccess,
  uploadCSVFailure, uploadEmails, uploadEmailsSuccess, uploadEmailsFailure,
} from './dashboard.actions';
import {
  generatePsyTest,
  generatePsyTestFailure,
  generatePsyTestSuccess,
} from '../psyTesting/psyTesting.actions';

export interface DashboardState {
  dashboard: any;
  services: any[];
  loading: boolean;
  error: any;

  // CSV Upload state
  uploadCSVResult: any | null;
  uploadCSVError: any | null;
  uploadCSVLoading: boolean;

  // Email Upload state
  uploadEmailsResult: any | null;
  uploadEmailsError: any | null;
  uploadEmailsLoading: boolean;
}

export const initialState: DashboardState = {
  dashboard: null,
  services: [],
  loading: false,
  error: null,

  // CSV Upload initial state
  uploadCSVResult: null,
  uploadCSVError: null,
  uploadCSVLoading: false,

  // Email Upload initial state
  uploadEmailsResult: null,
  uploadEmailsError: null,
  uploadEmailsLoading: false,
};

export const dashboardReducer = createReducer(
  initialState,

  on(dashboardInfo, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(dashboardInfoSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    result: result,
  })),

  on(dashboardInfoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  on(services, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(servicesSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    services: result,
  })),

  on(servicesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  on(storeService, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(storeServiceSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    result,
  })),

  on(storeServiceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // CSV Upload reducers
  on(uploadCSV, (state) => ({
    ...state,
    uploadCSVLoading: true,
    uploadCSVError: null,
    uploadCSVResult: null
  })),

  on(uploadCSVSuccess, (state, { result }) => ({
    ...state,
    uploadCSVLoading: false,
    uploadCSVResult: result,
    uploadCSVError: null
  })),

  on(uploadCSVFailure, (state, { error }) => ({
    ...state,
    uploadCSVLoading: false,
    uploadCSVError: error,
    uploadCSVResult: null
  })),

  // Email Upload reducers
  on(uploadEmails, (state) => ({
    ...state,
    uploadEmailsLoading: true,
    uploadEmailsError: null,
    uploadEmailsResult: null
  })),

  on(uploadEmailsSuccess, (state, { result }) => ({
    ...state,
    uploadEmailsLoading: false,
    uploadEmailsResult: result,
    uploadEmailsError: null
  })),

  on(uploadEmailsFailure, (state, { error }) => ({
    ...state,
    uploadEmailsLoading: false,
    uploadEmailsError: error,
    uploadEmailsResult: null
  }))
);
